import { Filter } from "./Filter";
export function categorize(actions, transactions) {
    actions.forEach((a) => {
        Filter.apply(a.filter, transactions).forEach(t => t.category = a.category);
    });
}
export function toStyle(styleRecord) {
    return styleRecord ? Object.entries(styleRecord).map(entry => entry[0] + ": " + entry[1] + "; ").join("") : "";
}
